export default __webpack_public_path__ + "static/media/linkedin.8fc6fb47.webp";